export { default as DateSelector } from 'pages/Optimisation/components/DateSelector/DateSelector';
